export default "__VITE_ASSET__i9mkGtkJ__"